import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";
import { CONSENT_STORAGE_KEY, setConsent, useCookieConsent } from "../hooks/useCookieConsent";

export const CookieBanner = () => {
  const consent = useCookieConsent();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!stored) {
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    if (consent) setVisible(false);
  }, [consent]);

  const handleChoice = (value) => {
    setConsent(value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 60 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-[60]"
          data-testid="cookie-banner"
        >
          <div className="bg-[#1A1A1A] text-white rounded-2xl shadow-[0_10px_40px_rgba(0,0,0,0.25)] p-6 md:p-8">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-[#C5A059]/20 flex items-center justify-center text-[#C5A059]">
                <Cookie size={20} />
              </div>
              <h3 className="font-playfair text-xl">Cookies</h3>
            </div>
            <p className="text-white/70 text-sm leading-relaxed mb-6">
              Wir verwenden nur technisch notwendige Speichermechanismen, um
              Ihre Präferenzen zu speichern. Mehr Informationen finden Sie in
              unserer{" "}
              <Link
                to="/datenschutz"
                className="text-[#C5A059] underline underline-offset-2 hover:text-white transition-colors"
                data-testid="cookie-privacy-link"
              >
                Datenschutzerklärung
              </Link>
              .
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <button
                onClick={() => handleChoice("accepted")}
                data-testid="cookie-accept-btn"
                className="flex-1 bg-[#C5A059] text-[#1A1A1A] px-6 py-3 rounded-full text-sm tracking-wider uppercase font-medium hover:bg-[#d4b06a] transition-colors duration-300"
              >
                Akzeptieren
              </button>
              <button
                onClick={() => handleChoice("declined")}
                data-testid="cookie-decline-btn"
                className="flex-1 border border-white/30 text-white px-6 py-3 rounded-full text-sm tracking-wider uppercase font-medium hover:bg-white/10 transition-colors duration-300"
              >
                Ablehnen
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
